export default "__VITE_ASSET__DJE0myBf__"